module.exports = __webpack_public_path__ + "static/img/Rachele.66ec676.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rachele.jpg
// module id = 3Pl+
// module chunks = 0